<script lang="ts">
  import type { Freshness } from '../types/Freshness';
  import { formatHHMMSS } from '../lib/format';
  import Chip from './chip.svelte';
  import ChipStrip from './chip-strip.svelte';

  interface Properties {
    /** Realtime freshness snapshot from the API. */
    freshness: Freshness;
  }

  const { freshness }: Properties = $props();

  /** Formats `unixSecs` as `HH:MM:SS`; `'never'` when null / non-positive / not a finite epoch. */
  function formatUpdated(unixSecs: bigint | null): string {
    if (unixSecs === null || unixSecs <= 0n) return 'never';
    const milliseconds = Number(unixSecs) * 1000;
    if (!Number.isFinite(milliseconds)) return 'never';
    return formatHHMMSS(new Date(milliseconds));
  }

  const timeLabel = $derived(formatUpdated(freshness.last_success_unix));
  const chipText = $derived(
    freshness.is_stale ? `Stale — updated ${timeLabel}` : `Updated ${timeLabel}`,
  );
</script>

<!-- Meta chip for realtime freshness. Warns visibly when the layer is stale so
     riders know the schedule fallback is in play. -->
<ChipStrip>
  <Chip tone={freshness.is_stale ? 'warn' : 'default'}>{chipText}</Chip>
</ChipStrip>
